import { createAsyncThunk } from "@reduxjs/toolkit";
import { Axios } from "api/axios";
import { WarehouseAxios } from "api/WarehouseAxios";
import { API_ENDPOINT } from "helpers/Endpoints/endpoints";
import { FilterBuilder } from "helpers/ThunkHelper/FilterBuilder";

const BASE_URL = "/item/"; // 🔧 Adjust base path as needed

// ✅ Fetch pending POs
export const fetchPendingPOs = createAsyncThunk(
  "pendingPO/fetchPendingPOs",
  async (
    {
      page,
      pageSize,
      sort,
      order,
      search,
      filters,
      warehouse_id,
    }: {
      page: number;
      pageSize: number;
      sort?: string;
      order?: "asc" | "desc" | "";
      search?: string;
      filters?: any;
      warehouse_id?: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const params = new URLSearchParams();
      params.append("page", page.toString());
      params.append("page_size", pageSize.toString());
      if (search) params.append("search", search);
      if (sort) {
        const orderingValue = order === "desc" ? `-${sort}` : sort;
        params.append("ordering", orderingValue);
      }
      if (warehouse_id) params.append("warehouse_id", warehouse_id);

      const filterPayload = FilterBuilder(filters ?? []);

      const body = {
        filters: filterPayload,
      };

      const res = await Axios.post(
        `${
          API_ENDPOINT?.WAREHOUSE?.ITEM_INWARD?.PENDING_PO?.LIST
        }?${params.toString()}`,
        body
      );
      console.log("pending PO lIsting : ", res);
      return {
        data: res.data.data || res.data.results || [],
        rowCount:
          res?.data?.count || res?.data?.total || res?.data?.total_records || 0,
      };
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch pending POs"
      );
    }
  }
);

// ✅ Fetch PO details by PO number
export const fetchPODetails = createAsyncThunk(
  "grn/fetchPODetails",
  async (poNumber: string, { rejectWithValue }) => {
    try {
      const res = await WarehouseAxios.get(
        `${BASE_URL}po_details/${poNumber}/`
      );
      return res.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch PO details"
      );
    }
  }
);

export const exportPendingPOCSV = async ({
  warehouse_id,
  search,
  filters,
}: {
  warehouse_id: string;
  search?: string;
  filters?: {
    filterField: string;
    filterValue: any;
  }[];
}) => {
  const params = new URLSearchParams();

  if (search) params.append("search", search);

  // -----------------------------
  // Build structured filters body
  // -----------------------------
  const filterPayload = FilterBuilder(filters ?? []);

  const body = {
    filters: filterPayload,
  };

  const response = await Axios.post(
    `${
      API_ENDPOINT?.WAREHOUSE?.ITEM_INWARD?.PENDING_PO?.EXPORT
    }?warehouse_id=${warehouse_id}&${params.toString()}`,
    body,
    { responseType: "blob" }
  );

  return {
    blob: response.data,
    filename:
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") ||
      `Pending_PO_${new Date().toISOString().split("T")[0]}.csv`,
  };
};
